import * as React from "react";
import { usePageTitle } from "../../hooks";
import { Divider, Typography } from "@mui/material";
import { FormattedMessage, MessageDescriptor } from "react-intl";

type Props = {
    title: MessageDescriptor;
    children: React.ReactNode;
    subtitle?: MessageDescriptor;
    titleValues?: { [s: string]: any };
};

const Page = ({ title, children, subtitle, titleValues }: Props) => {
    usePageTitle(title);

    return (
        <div>
            <div>
                <Typography variant="h5" style={{ padding: "0.2em 0" }}>
                    <FormattedMessage {...title} values={titleValues} />
                </Typography>
                {subtitle && (
                    <Typography variant="subtitle2" color="textSecondary">
                        <FormattedMessage {...subtitle} />
                    </Typography>
                )}
            </div>
            <Divider style={{ marginTop: "0.5em" }} />
            <div>{children}</div>
        </div>
    );
};

export default Page;
